export const GAME_VENDOR_FAV = "GAME_VENDOR_FAV";
export const UPDATE_GAME_VENDOR_FAV = "UPDATE_GAME_VENDOR_FAV";